import { alertsConstants } from '../constants';
import { v4 as uuid } from 'uuid';

const severeMap = {
  [alertsConstants.SUCCESS]: 'success',
  [alertsConstants.INFO]: 'info',
  [alertsConstants.ERROR]: 'error',
};
const getSeverity = (actionType: string) => {
  return severeMap[actionType];
};

interface EachStoreAlert {
  id: string;
  message: string;
  severity: string;
}

const initialState: EachStoreAlert[] = [];

export const alerts = (
  state = initialState,
  action: {
    type: string;
    payload: { id?: string; message?: string };
  },
) => {
  switch (action.type) {
    case alertsConstants.SUCCESS:
    case alertsConstants.INFO:
    case alertsConstants.ERROR:
      const severity = getSeverity(action.type);
      const newState = state.filter(
        (s) => s.message !== action.payload.message,
      );
      return [
        {
          id: action.payload.id || uuid(),
          severity,
          message: action.payload.message,
        },
        ...newState,
      ];
    case alertsConstants.CLEAR:
      const keyFocus =
        action.payload.id !== undefined ? 'id' : 'message';
      const valFocus = action.payload.id ?? action.payload.message;
      return state.filter((m) => m[keyFocus] !== valFocus);
    case alertsConstants.CLEAR_ALL:
      return [];
    default:
      return state;
  }
};
